// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accordion .accordion-item .accordion-button {
  --splash-danger-color: transparent;
  padding-top: 15px !important;
  padding-bottom: 15px !important;
  border-bottom: none !important;
  display: block;
}
.block-handle {
  cursor: grab;
  cursor: -webkit-grab;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: #e9ecef;
  box-shadow: 0px 4px 34px rgba(101, 96, 240, 0.1) !important;
}
.sortable-chosen .accordion-button {
  outline: 1px solid !important;
  outline-color: #d1d5db !important;
}
.sortable-chosen .block-handle {
  pointer-events: all !important;
  cursor: grabbing !important;
  cursor: -webkit-grabbing !important;
}
.sortable-chosen.sortable-ghost .block-handle {
  pointer-events: all !important;
  cursor: grabbing !important;
  cursor: -webkit-grabbing !important;
}
.sortable-chosen.sortable-ghost .card-body {
  outline: none;
  box-shadow: none;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
